import { Route } from '@angular/router';

export const appRoutes: Route[] = [
    {
        path: '',
        loadChildren: () => import('./home-planner/home-planner.routes').then(m => m.homePlannerRoutes)
    },
    {
        path: 'utils',
        loadChildren: () => import('./utils/utils/utils.routes').then(m => m.utilsRoutes)
    },
    {
        path: '**',
        redirectTo: ''
    }
];
